<template>
  <div class="row">
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons top />
      </form>
    </div>
    <div class="col-md-12">
      <h4>Deals</h4>
      <p>Please add any deals the provider has been involved in.</p>
      <form v-on:submit.prevent>
        <div>
          <button
            class="btn-default btn-create"
            style="margin-top: 0px; margin-left: 0px;"
            type="button"
            @click="createNewDeal"
          >
            Create new deal
          </button>
          <div v-for="(deal, index) in deals">
            <hr style="margin-top:20px;" />
            <inputForm :key="index" :index="index" />
          </div>
        </div>
      </form>
      <form v-on:submit.prevent="submit">
        <buttons />
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "../elements/textInput.vue";
import buttons from "../elements/buttons.vue";
import dealInputForm from "../elements/dealInputForm.vue";
import utils from "./utils.js";

export default {
  name: "deal-page",
  components: {
    textInput: textInput,
    inputForm: dealInputForm,
    buttons: buttons
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain"
    }),
    deals: function() {
      return this.getProperty(["relationships"]);
    }
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain"
    }),
    createNewDeal: function() {
      this.$store.commit("createNewProviderProperty", "relationships");
    },
    submit: function() {
      utils.post(this);
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dealPage.vue